<template>
  <div id="app">
    <router-view />

    <div v-if="$store.state.overlay.show" class="global-overlay">
      <div class="global-overlay__content">
        <div class="global-overlay__spinner"></div>
        <div v-if="$store.state.overlay.message" class="global-overlay__message">
          {{ $store.state.overlay.message }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
    }
  },

  // mounted () {
  //   this.$root.$on('googleSignInOnSuccess', (idToken, user) => {
  //     localStorage.setItem('idToken', idToken)
  //     localStorage.setItem('user', user)
  //     this.$router.replace('/discipleship/bahan-pa', () => {})
  //   })
  // },

  async created () {
    this.validateIdToken()
  },

  methods: {
    validateIdToken () {
      var idToken = localStorage.getItem('idToken')

      if (idToken === 'undefined' || idToken === undefined || idToken === null) {
        localStorage.clear()
        this.$router.replace('/login', () => {})
      } else {
        console.log('=>app.vue validateIdToken() true')
        this.$router.replace('/discipleship/bahan-pa', () => {})
      }
    }
  }
}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';

  .global-overlay {
    position: fixed;
    inset: 0;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.65);
  }

  .global-overlay__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 24px 32px;
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.08);
    backdrop-filter: blur(10px);
    color: #ffffff;
    text-align: center;
  }

  .global-overlay__spinner {
    width: 48px;
    height: 48px;
    border: 4px solid rgba(255, 255, 255, 0.25);
    border-top-color: #ffffff;
    border-radius: 50%;
    animation: overlay-spin 1s linear infinite;
    margin-bottom: 16px;
  }

  .global-overlay__message {
    font-size: 1rem;
    line-height: 1.5;
    max-width: 320px;
    word-break: break-word;
  }

  @keyframes overlay-spin {
    to {
      transform: rotate(360deg);
    }
  }
</style>
